import styled from 'styled-components'

import TitleWrapper from './TitleWrapper'

const SectionTitle = styled(TitleWrapper)``

export default SectionTitle
